import type { User } from 'firebase/auth';
import { createContext, useContext } from 'react';

export type AuthState =
  | { status: 'loading' }
  | { status: 'signed-out' }
  | { status: 'forbidden'; email: string }
  | { status: 'signed-in'; user: User; email: string };

export type AuthContextValue = {
  state: AuthState;
  signInWithGoogle: () => Promise<void>;
  signOutCurrentUser: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (ctx === null) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
